(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('navigateToInputError', NavigateToInputError);

    /** @ngInject */
    function NavigateToInputError() {
        function link(scope, element) {
            let form = element.controller('form');

            element.on('submit', (event) => {
                let firstInvalid = element[0].querySelector('.ng-invalid');

                if (firstInvalid) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(firstInvalid).offset().top - ($('.header').outerHeight() + 40)
                    }, 600);
                }

                // if (form.$error.required && form.$error.required.length) {
                //     let firstElement;
                //     let firstElementTop = 9999;

                //     for (let index = 0; index < form.$error.required.length; index++) {
                //         const element = form.$error.required[index].$$element[0];

                //         if ($(element).offset().top <= firstElementTop) {
                //             firstElement = element;
                //             firstElementTop = $(firstElement).offset().top;
                //         }
                //     }
                // }
            })
        }

        return {
            link: link,
            restrict: 'AE',
            scope: {}
        }
    }
}());